import { NodeToolbar, Position } from "@xyflow/react";
import { ReactNode } from "react";

type Props = {
  offset?: number;
  children: ReactNode;
};

export function NodeToolbarBottom({ offset = 10, children }: Props) {
  return (
    <NodeToolbar position={Position.Bottom} offset={offset} className="nopan">
      {children}
    </NodeToolbar>
  );
}
